import { Svg, Path } from "@react-pdf/renderer";
export const MathLogo = (): JSX.Element => {
	return (
		<Svg width="15" height="15" viewBox="0 0 30 30">
			<Path
				d="M0 6.736l.834.062C1.7 5.818 2.04 2.916 7.14 3.484c-.186 12.43-5.625 13.742-5.285 16.292.124 1.446 1.267 2.334 2.503 2.385 3.905-.134 3.73-5.41 4.945-18.708h5.037c-.267 4.688-.999 9.375-1.081 13.97.062 3.055 1.916 4.687 4.357 4.707 4.018.135 5.285-4.563 5.285-6.566h-.865c-.083 1.652-.876 2.84-2.565 2.911-4.605.062-2.07-8.115-2.04-14.96l5.47.031-.03-3.5C.132-.064 3.02-.511 0 6.736z"
				fill="#FC6C2E"
				fill-rule="evenodd"
			/>
		</Svg>
	);
};
